"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createTracker = exports.createClient = void 0;

var _Raven = _interopRequireDefault(require("Raven"));

var _enviro = _interopRequireDefault(require("enviro"));

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var _userInfo = _interopRequireDefault(require("hub-http/userInfo"));

var _PortalIdParser = _interopRequireDefault(require("PortalIdParser"));

var _I18n = _interopRequireDefault(require("I18n"));

var _getLang2 = _interopRequireDefault(require("I18n/utils/getLang"));

var _usageTrackerCore = require("usage-tracker-core");

var _storageKeys = require("usage-tracker-core/storageKeys");

var _events = _interopRequireDefault(require("draft-plugins/events.yaml"));

var _emptyFunction = _interopRequireDefault(require("react-utils/emptyFunction"));

var _tempStorage = require("./tempStorage");

var _utils = require("../lib/utils");

var reportError = function reportError(err) {
  var extras = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  _Raven.default.captureException(err, Object.assign({
    source: 'draft-plugins usage tracking'
  }, extras));
};

var reportNetworkError = function reportNetworkError(err) {
  return reportError(err, {
    fingerPrint: ['usage-tracker-js', 'network']
  });
};

var createClient = function createClient() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$client = _ref.client,
      client = _ref$client === void 0 ? _apiClient.default : _ref$client,
      _ref$getUserInfo = _ref.getUserInfo,
      getUserInfo = _ref$getUserInfo === void 0 ? _userInfo.default : _ref$getUserInfo;

  var path = 'usage-logging/v1/log/hublytics-multi/no-auth';

  var getEmail = function getEmail() {
    return getUserInfo({
      ignoreRedirect: true
    }).then(function (_ref2) {
      var _ref2$user = _ref2.user,
          user = _ref2$user === void 0 ? null : _ref2$user;
      return user != null ? user.email : null;
    }).catch(function () {
      return null;
    });
  };

  return (0, _usageTrackerCore.createClient)({
    getDebug: function getDebug() {
      return _enviro.default.debug(_storageKeys.debugKey);
    },
    getEmail: getEmail,
    getHubId: function getHubId() {
      return _PortalIdParser.default.get() || null;
    },
    getHstc: function getHstc() {
      return null;
    },
    getLang: function getLang() {
      return _I18n.default.Info.then(_getLang2.default);
    },
    getTempStorage: _tempStorage.getTempStorage,
    setTempStorage: _tempStorage.setTempStorage,
    reportError: reportError,
    send: function send(_ref3) {
      var events = _ref3.events,
          query = _ref3.query,
          isAuthed = _ref3.isAuthed;
      var endpoint = path + "?" + query;
      var data = events;

      var sendXhr = function sendXhr() {
        var promise;

        if (isAuthed) {
          promise = client.post(endpoint, {
            data: data
          }).catch(reportNetworkError);
        }

        if (promise && typeof promise.done === 'function') {
          promise.done();
        }
      };

      sendXhr();
    }
  });
};

exports.createClient = createClient;

var createTracker = function createTracker(client) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if ((0, _utils.isInternal)()) {
    return {
      track: _emptyFunction.default
    };
  }

  if (!client) {
    client = createClient();
  }

  var configWithDefaults = Object.assign({
    events: _events.default,
    properties: {
      namespace: 'rich-text',
      text_library: 'draft.js'
    }
  }, config);
  return client.createTracker(configWithDefaults);
};

exports.createTracker = createTracker;